import { CheckedComponentInformation } from '@west-australian-newspapers/json-react-layouts'
import { Topic } from '@news-mono/web-common'
import { layout } from '../../../../App.routing'
import {
    getCricketCurationLimaComponent,
    getCricketCurationSieraComponent,
} from '../cricket-route-component-layouts'
import { billboardLeaderboardMrec } from '../../../ad-units'

const bannerDesktop = require<string>('./assets/2025-Summer-of-Cricket-Banner.webp')
const socialImage = require('./assets/2025-Summer-of-Cricket-Social-Image.jpg')

export const getSummerOfCricketSocialImageMeta = () => [
    {
        property: 'og:image',
        content: socialImage,
    },
    {
        property: 'og:image:width',
        content: '1920',
    },
    {
        property: 'og:image:height',
        content: '1080',
    },
    { name: 'twitter:image', content: socialImage },
]

export const getSummerOfCricketLayout = (
    topic: Topic,
): CheckedComponentInformation[] => {
    return [
        layout.component({
            type: 'image-banner',
            props: {
                defaultSrc: bannerDesktop,
                verticalGutters: ['unset', 'md'],
                altText: topic.seoTitle,
                disableHeader: true,
            },
        }),
        layout.nestedComposition({
            type: 'janus',
            props: {
                layoutRatio: '3:1',
                stretchColumns: true,
                verticalSpacing: 'xl',
            },
            contentAreas: {
                left: [getCricketCurationSieraComponent()],
                right: [
                    layout.component({
                        type: 'summer-of-cricket-promo-card',
                        props: {},
                    }),
                ],
            },
        }),
        getCricketCurationLimaComponent(),
        ...billboardLeaderboardMrec('one'),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                loadMoreEnabled: true,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: 'Latest Cricket News',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: [
                        'sport/australian-cricket-team',
                        'sport/big-bash-league',
                        'sport/cricket-world-cup',
                        'sport/indian-premier-league',
                        'sport/the-ashes',
                        'sport/perth-scorchers',
                        'sport/womens-cricket',
                    ],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 8,
                    },
                },
            },
        }),
        ...billboardLeaderboardMrec('two'),
    ]
}
